import { format } from 'date-fns';

const buildPParams = (params) =>
  Array.from({ length: 10 }).reduce((acc, _, i) => {
    acc[`p${i + 1}`] = params[`p${i + 1}`] || null;
    return acc;
  }, {});

class ApiSender {
  constructor() {
  }

  async sendPin(endpoint, msisdn, language = 'AR') {
    const baseUrl = process.env.REACT_APP_IRAQ_BASE_URL;
    const url = `${baseUrl}/${endpoint}/${msisdn}?language=${language}`;
    const headers = { 'Content-Type': 'application/json' };
    try {
      const response = await fetch(url, { method: 'POST', headers });

      const isJson = response.headers.get("content-type")?.includes("application/json");
      const result = isJson ? await response.json() : null;

      if (!response.ok || !result) {
        throw new Error();
      }

      return { success: result.code === 2000, message: result.message };
    }
    catch (error) {
      return { success: false, message: (language === 'EN' ? 'Failed to send PIN' : 'فشل إرسال رقم التعريف الشخصي') };
    }
  };

  async verifyPin(endpoint, msisdn, pin, transactionId, conversionGoalId, conversionGoalName, landingPageUrl, landingPageName, paramsObject = {}, language = 'AR',
    ti, ts
  ) {
    const baseUrl = process.env.REACT_APP_IRAQ_BASE_URL;
    const url = `${baseUrl}/${endpoint}?language=${language}`;
    const headers = { 'Content-Type': 'application/json', };
    const formattedDateTime = format(new Date(), 'yyyy-MM-dd HH:mm:ssxxx');
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const payload = {
      msisdn,
      pin,
      campaignId: paramsObject.campaignId || null,
      trackerId: paramsObject.trackerId || null,
      transactionId,
      googleTrackerId: paramsObject.gclid || null,
      gbraid: paramsObject.gbraid || null,
      wbraid: paramsObject.wbraid || null,
      conversionDateTime: formattedDateTime,
      conversionGoalId,
      conversionGoalName,
      landingPageUrl,
      landingPageName,
      ...buildPParams(paramsObject),
      timezone,
      ti,
      ts
    };
    try {
      const response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(payload) });

      const isJson = response.headers.get('content-type')?.includes('application/json');
      const result = isJson ? await response.json() : null;

      if (!response.ok || !result) {
        throw new Error();
      }

      return { success: result.code === 2000, message: result.message };
    }
    catch (error) {
      // this.loadDcbProtectScript();
      // const dcb = window.__DCB_PROTECT__ || { ti: null, ts: null, type: null };
      return { success: false, message: (language === 'EN' ? 'PIN verification failed' : 'فشل التحقق من رقم التعريف الشخصي'), ti: null, ts: null };
    }
  };

  async subscribeHe(endpoint, ti, ts, conversionGoalId, conversionGoalName, landingPageUrl, landingPageName, paramsObject = {}, language = 'AR') {
    const baseUrl = process.env.REACT_APP_IRAQ_BASE_URL;
    const url = `${baseUrl}/${endpoint}?language=${language}`;
    const headers = { 'Content-Type': 'application/json', };
    const formattedDateTime = format(new Date(), 'yyyy-MM-dd HH:mm:ssxxx');
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const payload = {
      transactionId: ti,
      campaignId: paramsObject.campaignId || null,
      trackerId: paramsObject.trackerId || null,
      googleTrackerId: paramsObject.gclid || null,
      mfId: paramsObject.mfid || null,
      mfToken: paramsObject.mf_token || null,
      gbraid: paramsObject.gbraid || null,
      wbraid: paramsObject.wbraid || null,
      conversionDateTime: formattedDateTime,
      conversionGoalId,
      conversionGoalName,
      landingPageUrl,
      landingPageName,
      ...buildPParams(paramsObject),
      timezone
    };
    try {
      const response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(payload) });
      if (!response.ok) throw new Error();
      if (!ti || !ts) throw new Error();
      const { status, code } = await response.json();
      if (status && code === 2000) {
        const he_api_base = process.env.REACT_APP_IRAQ_HE_URL;
        const serviceId = 721;
        const spId = 203;
        const shortcode = 3368;
        const servicename = 'gameland';
        const merchantname = 'strongbits';
        const redirectionUrl = `${he_api_base}?serviceId=${serviceId}&spId=${spId}&shortcode=${shortcode}&ti=${ti}&ts=${ts}&servicename=${servicename}&merchantname=${merchantname}`;
        window.location.replace(redirectionUrl);
        return { success: true };
      }
      return { success: false };
    }
    catch (error) {
      return { success: false };
    }
  };

  async saveHistory(landingPageUrl, params = {}) {
    try {
      const isCampaign = ['campaignId'].some(key => key in params);
      if (!isCampaign) return;
      const isGoogleCampaign = ['gclid', 'gbraid', 'wbraid'].some(key => key in params);
      if (!isGoogleCampaign) return;
      const baseUrl = process.env.REACT_APP_GOOGLE_BASE_URL;
      const endpoint = "google/visit";
      const url = `${baseUrl}/${endpoint}`;
      const googleParamKeys = [
        "gclid", "gbraid", "wbraid", "campaignId", "conversions", "cost_micros", "cpa",
        "utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content",
        "ad_group_id", "ad_group_name", "ad_id", "keyword_id", "keyword_text",
        "match_type", "clicks", "impressions", "ctr", "average_cpc",
        "conversion_date", "click_date", "geo_location", "device"
      ];
      const extraParamsObject = Object.keys(params).reduce((acc, key) => {
        if (!googleParamKeys.includes(key)) {
          acc[key] = params[key];
        }
        return acc;
      }, {});
      const payload = {
        gclid: params.gclid || null,
        gbraid: params.gbraid || null,
        wbraid: params.wbraid || null,
        campaign: params.campaignId || null,
        conversions: params.conversions || null,
        costMicros: params.cost_micros || null,
        cpa: params.cpa || null,
        utmSource: params.utm_source || null,
        utmMedium: params.utm_medium || null,
        utmCampaign: params.utm_campaign || null,
        utmTerm: params.utm_term || null,
        utmContent: params.utm_content || null,
        adGroupId: params.ad_group_id || null,
        adGroupName: params.ad_group_name || null,
        adId: params.ad_id || null,
        keywordId: params.keyword_id || null,
        keywordText: params.keyword_text || null,
        matchType: params.match_type || null,
        clicks: params.clicks || null,
        impressions: params.impressions || null,
        ctr: params.ctr || null,
        averageCpc: params.average_cpc || null,
        conversionDate: params.conversion_date || null,
        clickDate: params.click_date || null,
        geoLocation: params.geo_location || null,
        device: params.device || null,
        landingPageUrl: landingPageUrl || null,
        extraParams: JSON.stringify(extraParamsObject)
      };

      await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) });
    }
    catch (error) {
    }
  };

  async isZainUser() {
    const baseUrl = process.env.REACT_APP_IRAQ_BASE_URL;
    const endpoint = "/check-user";

    try {
      const response = await fetch(`${baseUrl}${endpoint}`, { method: 'GET' });

      if (!response.ok) {
        return { success: true };
      }

      const result = await response.json();
      return { success: result?.status === true };
    }
    catch (error) {
      return { success: true };
    }
  };

  async loadDcbProtectScript() {
    // Remove old injected script first
    var existing = document.getElementById("dcbprotect-script");
    if (existing) {
      existing.remove();
    }

    var fraudApi = "http://www.social-sms.com/iq-dcb/dcbprotect.php"; // prefer https
    var teSelector = "#subscribe-btn";
    var te = teSelector;

    var ts = Date.now();

    var ti = "GL-SB-" + (
      (window.crypto && window.crypto.randomUUID)
        ? crypto.randomUUID() + "-" + ts
        : String(ts) + "-" + Math.random().toString(16).slice(2)
    );

    var servicename = "gameland";
    var merchantname = "strongbits";
    var type = "pin";

    window.__DCB_PROTECT__ = { ti: ti, ts: ts, type: type };

    var params = new URLSearchParams({
      action: "script",
      ti: ti,
      ts: String(ts),
      te: te,
      servicename: servicename,
      merchantname: merchantname,
      type: type,
    });

    var url = fraudApi + "?" + params.toString();

    return fetch(url, {
      headers: { Accept: "application/json" },
      cache: "no-store",
    })
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.s) {
          return window.__DCB_PROTECT__;
        }

        var oldScript = document.getElementById("dcbprotect-script");
        if (oldScript) {
          oldScript.remove();
        }

        var sc = document.createElement("script");
        sc.id = "dcbprotect-script";
        sc.type = "text/javascript";
        sc.innerHTML = data.s;
        document.head.appendChild(sc);

        document.dispatchEvent(new Event("DCBProtectRun"));

        return window.__DCB_PROTECT__;
      })
      .catch(function (e) {
        console.error("DCBProtect loader failed:", e);
        throw e;
      });
  };

  async getCampaign(campaignId) {
    if (!campaignId) {
      return;
    }
    const baseUrl = process.env.REACT_APP_IRAQ_BASE_URL;
    try {
      const response = await fetch(`${baseUrl}/ill?campaignId=${campaignId}`, { method: 'GET', headers: { 'Content-Type': 'application/json' } });

      if (!response.ok) {
        throw new Error(`Failed to fetch campaign: ${response.statusText}`);
      }

      const data = await response.json();
      return data;
    }
    catch (error) {
      return;
    }
  };

  async getGoalsInfo(campaignId) {
    if (!campaignId) {
      return { success: false, goalId: null, goalName: null };
    }
    const baseUrl = process.env.REACT_APP_GOOGLE_BASE_URL;
    try {
      const response = await fetch(`${baseUrl}/campaign/info?uuid=${campaignId}`, { method: 'GET', headers: { "Content-Type": "application/json" } });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const { status, goalId, goalName } = await response.json();
      return {
        success: status || false,
        goalId: goalId || null,
        goalName: goalName || null
      };
    } catch (error) {
      return { success: false, goalId: null, goalName: null };
    }
  }

  async fSubscribe(ti, ts, conversionGoalId, conversionGoalName, landingPageUrl, landingPageName, paramsObject = {}, language = 'AR') {
    if (!paramsObject.campaignId) {
      return { success: false };
    }
    const baseUrl = process.env.REACT_APP_IRAQ_BASE_URL;
    const url = `${baseUrl}/game/campaign?language=${language}`;
    const headers = { 'Content-Type': 'application/json', };
    const formattedDateTime = format(new Date(), 'yyyy-MM-dd HH:mm:ssxxx');
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const payload = {
      transactionId: ti,
      campaignId: paramsObject.campaignId || null,
      trackerId: paramsObject.trackerId || null,
      googleTrackerId: paramsObject.gclid || null,
      mfId: paramsObject.mfid || null,
      mfToken: paramsObject.mf_token || null,
      gbraid: paramsObject.gbraid || null,
      wbraid: paramsObject.wbraid || null,
      conversionDateTime: formattedDateTime,
      conversionGoalId,
      conversionGoalName,
      landingPageUrl,
      landingPageName,
      ...buildPParams(paramsObject),
      timezone
    };
    try {
      const response = await fetch(url, { method: 'POST', headers, body: JSON.stringify(payload) });
      if (!response.ok) throw new Error();
      if (!ti || !ts) throw new Error();
      const { status, code } = await response.json();
      if (status && code === 2000) {
        const he_api_base = process.env.REACT_APP_IRAQ_HE_URL;
        const serviceId = 721;
        const spId = 203;
        const shortcode = 3368;
        const servicename = 'gameland';
        const merchantname = 'strongbits';
        const redirectionUrl = `${he_api_base}?serviceId=${serviceId}&spId=${spId}&shortcode=${shortcode}&ti=${ti}&ts=${ts}&servicename=${servicename}&merchantname=${merchantname}`;
        window.location.replace(redirectionUrl);
        return { success: true };
      }
      return { success: false };
    }
    catch (error) {
      return { success: false }
    }
  };
}

export default ApiSender;  